import React from 'react';
import { Form, TextAreaBox, Switch, IntBox } from 'fw/forms';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Label, Tooltip, Button } from 'fw/components'
import { ContentBody, VeteranAppIdHeader } from 'areas/shared/components';
import { DocumentUpload } from "areas/shared/controls";
import BusinessNAICSCode from './businessNAICSCodes';
import BusinessStaff from './businessStaff';
import BusinessStaffPopUp from './businessStaffPopUp';
import * as Notifications from 'fw/globals/Notifications';
import * as FormManager from 'fw/forms/form/FormManager';
import { TooltipCode } from 'areas/shared/consts';

class BusinessStructure extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
        this.businessStructureStaffId = -1
    }

    initialState = () => {
        return {
            form: this.props.stepData,
            showBusinessStaffPopUp: false,
            currentBusinessStaff: this.newBusinessStaff(),
            tooltips: this.props.stepInfo.tooltips
        };
    }

    componentDidMount() {
        if (this.state.form.naicsCodes.length === 0) {
            this.addNaicsCode();
        }
    }

    addNaicsCode = () => {
        let item = {
            naicsCodeId: 0,
            naicsCode: "",
            naicsDescription: ""
        }

        let form = this.state.form;
        form.naicsCodes = form.naicsCodes.concat(item)

        this.updatePostData(form);
    }

    onNaicsCodesRemove = (index) => {
        let form = this.state.form;

        form.naicsCodes.splice(index, 1);

        this.updatePostData(form, true);
    }

    onNaicsCodesChange = (index, item) => {
        let form = this.state.form;

        form.naicsCodes[index] = item;

        this.updatePostData(form, true);
    }

    onBusinessStaffClose = () => {
        this.setState({
            showBusinessStaffPopUp: false
        });
    }

    onBusinessStaffEdit = (index) => {
        this.setState({
            showBusinessStaffPopUp: true,
            currentBusinessStaff: this.state.form.businessStaff[index],
        });
    }

    onBusinessStaffChange = (businessStaff) => {
        let form = this.state.form;

        var index = form.businessStaff.findIndex(function (element) {
            return element.businessFunctionId === businessStaff.businessFunctionId;
        });

        if (index >= 0)
            form.businessStaff[index] = businessStaff;
        else
            form.businessStaff = form.businessStaff.concat(businessStaff);

        if (businessStaff.businessStructureStaffId > 0)
            Notifications.success("The Staff Member has been updated.");
        else
            Notifications.success("The Staff Member has been added.");

        this.updatePostData(form, true);
    }

    onBusinessStaffGridChange = (businessStaff) => {
        let form = this.state.form;

        var index = form.businessStaff.findIndex(function (element) {
            return element.businessFunctionId === businessStaff.businessFunctionId
        })

        form.businessStaff[index] = businessStaff;

        this.updatePostData(form, true)
    }

    newBusinessStaff = () => {
        let item = {
            businessStructureStaffId: this.businessStructureStaffId,
            firstName: "",
            lastName: "",
            title: "",
            businessFunctionId: null,
            functionName: "",
            otherFunction: "",
            email: "",
            phones: []
        }

        this.businessStructureStaffId--;
        return item;
    }

    updatePostData = (form, dirty) => {
        this.checkBlankFields(form);
        this.setState({ form });
        this.props.onStepChange(form);

        if (dirty === true)
            FormManager.dirt(this._form);
    }

    checkBlankFields = (form) => {
        //check Question 1 fields
        if (!form.shareResources)
            form.shareResourcesDescription = null;
        //check Question 2 fields
        if (!form.subsidiary) {
            form.subsidiaryStorageToken = null;
            form.subsidiaryFileName = null;
        }
        //check Question 3 fields
        if (!form.otherAgreement) {
            form.otherAgreementStorageToken = null;
            form.otherAgreementFileName = null;
            form.otherAgreementMembersStorageToken = null;
            form.otherAgreementMembersFileName = null;
            form.otherAgreementOwnerStorageToken = null;
            form.otherAgreementOwnerFileName = null;
        }
    }

    handleSubsidiaryUploadChange = (file) => {
        let form = this.state.form;
        form.subsidiaryStorageToken = file.storageToken;
        form.subsidiaryFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleOtherAgreementUploadChange = (file) => {
        let form = this.state.form;
        form.otherAgreementStorageToken = file.storageToken;
        form.otherAgreementFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleOtherAgreementMembersUploadChange = (file) => {
        let form = this.state.form;
        form.otherAgreementMembersStorageToken = file.storageToken;
        form.otherAgreementMembersFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleOtherAgreementOwnerUploadChange = (file) => {
        let form = this.state.form;
        form.otherAgreementOwnerStorageToken = file.storageToken;
        form.otherAgreementOwnerFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleCapabilitiesStatementUploadChange = (file) => {
        let form = this.state.form;
        form.capabilitiesStatementStorageToken = file.storageToken;
        form.capabilitiesStatementFileName = file.fileName;

        this.updatePostData(form, true);
    }

    handleProfessionalAccreditationUploadChange = (file) => {
        let form = this.state.form;
        form.professionalAccreditationStorageToken = file.storageToken;
        form.professionalAccreditationFileName = file.fileName;

        this.updatePostData(form, true);
    }

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.tip : null
    }

    render() {
        return (
            <Form
                onChange={this.updatePostData}
                values={this.state.form}
                unsavedChangesWarning={true}
                disabled={this.props.stepInfo.readonly}
                ref={(form) => { this._form = form }}>
                <ContentBody>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h3 style={{ position: 'relative' }}>
                                        Capabilities Statement<small className="required-indicator"> *</small>
                                        <Label tip={this.setTip(TooltipCode.BUSINESS.CAPSTATEMENT)} />
                                        <VeteranAppIdHeader appId={this.state.form.certificationId} daysOpen={this.props.stepInfo.daysOpen} /></h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8} style={{ marginTop: "5px" }}>
                                    <TextAreaBox
                                        name="capabilitiesStatement"
                                        maxLength={10000}
                                        rows={4}
                                        placeholder="Please describe your Products and Services. It’s important to note that this statement will be used by Corporate Members to match your capabilities with their needs" />
                                </Col>
                                <Col md={4}>
                                    <Label tip={this.setTip(TooltipCode.BUSINESS.CAPUPLOAD)}>Capabilities Upload</Label>
                                    <DocumentUpload
                                        storageToken={this.state.form.capabilitiesStatementStorageToken}
                                        fileName={this.state.form.capabilitiesStatementFileName}
                                        onChange={this.handleCapabilitiesStatementUploadChange}
                                        wrapFileNameLength={40}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h3>
                                        Professional Accreditation
                                        <Label tip={this.setTip(TooltipCode.BUSINESS.PROFACCREDITATION)} />
                                    </h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8} style={{ marginTop: "5px" }}>
                                    <TextAreaBox
                                        name="professionalAccreditation"
                                        maxLength={5000}
                                        rows={4}
                                        placeholder="Please describe any Certificates or Accreditation your business holds" />
                                </Col>
                                <Col md={4}>
                                    <Label tip={this.setTip(TooltipCode.BUSINESS.ACRUPLOAD)}>Accreditation Upload</Label>
                                    <DocumentUpload
                                        storageToken={this.state.form.professionalAccreditationStorageToken}
                                        fileName={this.state.form.professionalAccreditationFileName}
                                        onChange={this.handleProfessionalAccreditationUploadChange}
                                        wrapFileNameLength={40}  />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h3>Business Relationships</h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label tip={this.setTip(TooltipCode.BUSINESS.SHARERESQUESTION)}>
                                                    Does the Company share any resources with other firms or individuals?
                                                </Label>
                                                <Switch name="shareResources" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label tip={this.setTip(TooltipCode.BUSINESS.SUBSIDIARYQUESTION)}>
                                                    Is this company a subsidiary of another company?
                                                </Label>
                                                <Switch name="subsidiary" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <FormGroup>
                                                <Label tip={this.setTip(TooltipCode.BUSINESS.OTHERAGREEMENT)}>
                                                    Does this business, owner or employee intend to enter into any form of agreement with any other business, which would affect the administration, management or operations?
                                                </Label>
                                                <Switch name="otherAgreement" labelLeft="No" labelRight="Yes" bsStyle="primary" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={6}>
                                    {this.state.form.shareResources ?
                                        (<Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label tip={this.setTip(TooltipCode.BUSINESS.SHARERESDESC)} required>Please explain (500 characters maximum)</Label>
                                                    <TextAreaBox name="shareResourcesDescription" maxLength={500} rows={3} />
                                                </FormGroup>
                                            </Col>
                                        </Row>) : null}
                                    {this.state.form.subsidiary ?
                                        (<Row>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Label tip={this.setTip(TooltipCode.BUSINESS.SUBSIDIARYDESC)} required>
                                                        Please upload a list of companies, and a brief description of the relationship with each. Please remember to include each business name, address (business and mailing), telephone numbers and names of contacts.
                                                    </Label>
                                                    <DocumentUpload
                                                        storageToken={this.state.form.subsidiaryStorageToken}
                                                        fileName={this.state.form.subsidiaryFileName}
                                                        onChange={this.handleSubsidiaryUploadChange} />
                                                </FormGroup>
                                            </Col>
                                        </Row>) : null}
                                    {this.state.form.otherAgreement ?
                                        (<React.Fragment>
                                            <Row>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label tip={this.setTip(TooltipCode.BUSINESS.AGRUPLOAD)} required>
                                                            Please upload a copy of any agreement, or explanation of any agreement (oral or intended).
                                                        </Label>
                                                        <DocumentUpload
                                                            storageToken={this.state.form.otherAgreementStorageToken}
                                                            fileName={this.state.form.otherAgreementFileName}
                                                            onChange={this.handleOtherAgreementUploadChange} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label tip={this.setTip(TooltipCode.BUSINESS.AFFECTEDLISTUPOAD)} required>
                                                            Please upload a list of those who would be affected by the above agreement.
                                                            Please include the titles of all owners, members, corporate shareholders and limited liability members.
                                                        </Label>
                                                        <DocumentUpload
                                                            storageToken={this.state.form.otherAgreementMembersStorageToken}
                                                            fileName={this.state.form.otherAgreementMembersFileName}
                                                            onChange={this.handleOtherAgreementMembersUploadChange} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <FormGroup>
                                                        <Label tip={this.setTip(TooltipCode.BUSINESS.COLISTUPLOAD)} required>
                                                            Please upload a list of any company owner or manager associated with another business. Please include a brief description for each business, as well as the relationship of the owner or manager to the business. Please include the business name, address (business and mailing), telephone numbers and names of contacts.
                                                        </Label>
                                                        <DocumentUpload
                                                            storageToken={this.state.form.otherAgreementOwnerStorageToken}
                                                            fileName={this.state.form.otherAgreementOwnerFileName}
                                                            onChange={this.handleOtherAgreementOwnerUploadChange} />
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </React.Fragment>) : null}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <Label>
                                        <h3>
                                            NAICS Codes
                                            <small className="required-indicator"> *</small>
                                        </h3>
                                    </Label>
                                    { this.setTip(TooltipCode.BUSINESS.NAICSCODES) && <Tooltip tip={this.setTip(TooltipCode.BUSINESS.NAICSCODES)}/> }
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={9}>
                                    <BusinessNAICSCode naicsCodes={this.state.form.naicsCodes}
                                        onRemove={this.onNaicsCodesRemove}
                                        onChange={this.onNaicsCodesChange} />
                                </Col>
                                <Col md={3}>
                                    <a href="https://www.naics.com/search/" target="_blank" rel="noopener noreferrer">See current NAICS Codes here</a>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <br />
									<Button type="button" bsStyle="link" onClick={() => this.addNaicsCode()}>
										Add more NAICS Codes
									</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Row>
                                <Col md={12}>
                                    <h3>Staff &amp; Responsibilities – <small>Please identify primary decision makers within your Company</small>
                                        <small className="required-indicator"> *</small></h3>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <BusinessStaffPopUp
                                        visible={this.state.showBusinessStaffPopUp}
                                        onClose={this.onBusinessStaffClose}
                                        onSave={this.onBusinessStaffChange}
                                        currentBusinessStaff={this.state.currentBusinessStaff} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <BusinessStaff
                                        businessStaff={this.state.form.businessStaff}
                                        majorityOwner={this.state.form.majorityOwner}
                                        onEdit={this.onBusinessStaffEdit}
                                        onChange={this.onBusinessStaffGridChange} />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}><br /></Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label tip={this.setTip(TooltipCode.BUSINESS.NUMBERFULLTIMEEE)}>
                                            Number of Full-Time Employees
                                        </Label>
                                        <IntBox
                                            name="amountFullTimeEmployee"
                                            placeholder="# Full-Time Employees"
                                            maxLength={9}
                                            style={{ width: "200px" }} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label tip={this.setTip(TooltipCode.BUSINESS.NUMBERVETERANEE)}>
                                            Number of Veteran Employees
                                        </Label>
                                        <IntBox
                                            name="amountVeteranEmployee"
                                            placeholder="# Veteran Employees"
                                            maxLength={9}
                                            style={{ width: "200px" }} />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label tip={this.setTip(TooltipCode.BUSINESS.NUMBERPARTTIMEEE)}>
                                            Number of Part-Time Employees
                                        </Label>
                                        <IntBox
                                            name="amountPartTimeEmployee"
                                            placeholder="# Part-Time Employees"
                                            maxLength={9}
                                            style={{ width: "200px" }} />
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label tip={this.setTip(TooltipCode.BUSINESS.NUMBERPARTTIMECTR)}>
                                            Number of Contractor(s) or 1099 Recipients
                                        </Label>
                                        <IntBox
                                            name="amountContractor"
                                            placeholder="# Contractor/1099 Employees"
                                            maxLength={9}
                                            style={{ width: "200px" }} />
                                    </FormGroup>
                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </ContentBody>
            </Form>
        )
    }
}

export default BusinessStructure;



// WEBPACK FOOTER //
// ./src/areas/certification/steps/businessStructure/BusinessStructure.js